import {Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';

@Directive({
  selector: '[nbSortable]'
})
export class SortableDirective implements OnInit {

  @Input() nbSortable: 'asc' | 'desc';
  private el: ElementRef;
  private indicator: any;

  @Output() sort = new EventEmitter<'asc' | 'desc'>();

  constructor(el: ElementRef) {
    this.el = el;
  }

  ngOnInit(): void {
    this.el.nativeElement.className = this.el.nativeElement.className + ' nb-sortable';
    this.indicator = document.createElement('i');
    this.indicator.className = this.iconClass;
    this.el.nativeElement.appendChild(this.indicator);
  }

  get iconClass() {
    if (this.nbSortable === 'asc') {
      return 'fas fa-sort-amount-down-alt float-right nb-sortable-indicator';
    } else if (this.nbSortable === 'desc') {
      return 'fas fa-sort-amount-down float-right nb-sortable-indicator';
    }
    return 'd-none nb-sortable-indicator';
  }

  @HostListener('click') onClick() {
    if (this.indicator.className.indexOf('d-none') > 0) {
      this.nbSortable = 'asc';
    } else if (this.nbSortable === 'desc') {
      delete this.nbSortable;
    } else if (this.nbSortable === 'asc') {
      this.nbSortable = 'desc';
    } else {
      this.nbSortable = 'asc';
    }
    (window as any).jQuery('.nb-sortable-indicator').addClass('d-none');
    this.update();
  }

  private update() {
    this.indicator.className = this.iconClass;
    this.el.nativeElement.removeChild(this.el.nativeElement.lastElementChild);
    this.el.nativeElement.appendChild(this.indicator);
    this.sort.emit(this.nbSortable);
  }
}
